import { cn } from "@reactive-resume/utils";
import { forwardRef } from "react";

export type InputProps = {
  hasError?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hasError = false, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      autoComplete="off"
      className={cn(
        "border-border hover:border-primary/40 focus:border-primary focus:bg-secondary/10 flex h-9 w-full [appearance:textfield] rounded border bg-transparent px-3 py-0.5 !text-sm ring-0 ring-offset-transparent transition-colors placeholder:opacity-80 focus-visible:ring-0 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
        "file:text-primary file:border-0 file:bg-transparent file:pt-1 file:text-sm file:font-medium",
        hasError ? "border-error" : "border-border",
        className,
      )}
      {...props}
    />
  ),
);

Input.displayName = "Input";
